import { CodePensPage } from "pages/CodePensPage";
import { ContactPage } from "pages/ContactPage";
import { HomePage } from "pages/HomePage";
import { ProjectsByTechPage } from "pages/ProjectsByTechPage";
import { ProjectsPage } from "pages/ProjectsPage";
import { Route, Switch } from "react-router-dom";

export function SwitchViewApp() {
    return (
        <Switch>
            <Route path="/" component={HomePage} exact />
            <Route path="/ui-components" component={CodePensPage} />
            <Route path="/contact-me" component={ContactPage} />
            <Route path="/projects" component={ProjectsPage} />
            <Route path="/projects/:technologySelected" component={ProjectsByTechPage} />
        </Switch>
    )
}